import React from 'react';
import { useLocation, Redirect } from 'react-router';
import { UserName } from '../containers/UserName';

export const AppContainer: React.FC = ({ children }) => {
    const location = useLocation();
    const { userName } = UserName.useContainer();

    // Redirect to the login page if we aren't logged in
    if (!userName && location.pathname !== '/login') {
        return <Redirect to={`/login?redirect=${encodeURI(location.pathname)}`} />;
    }
    return <>{children}</>;
};

